import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import TextField from "@material-ui/core/TextField";
import { FileUpload } from "primereact/fileupload";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import "bootstrap/dist/css/bootstrap.min.css";
import { Dropdown } from "primereact/dropdown";
import { ToastContainer, toast } from "react-toastify";
import {
  roleMasterActions,
  dealerMasterActions,
  userMasterActions,
} from "../../actions";
import tableRequest from "../../models/tableRequest";
import Switch from "@material-ui/core/Switch";
import { Calendar } from "primereact/calendar";
import { CSVLink } from "react-csv";
import { event } from "jquery";
import DistributorSection from "./Distributorsection";
import { de } from "date-fns/locale";

function formatApiDateTime(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00`;
}

class dealerMaster extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.exportCSV = this.exportCSV.bind(this);
    this.tblResponse = new tableRequest();
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

    this.onHide = this.onHide.bind(this);
    this.getStateList = this.getStateList.bind(this);
    this.getFirmList = this.getFirmList.bind(this);
    this.GetPaymentDDL = this.GetPaymentDDL.bind(this);
    this.GetDocumentTypeDDl = this.GetDocumentTypeDDl.bind(this);
    this.GetALLSalesPersonList = this.GetALLSalesPersonList.bind(this);
    this.getCityList = this.getCityList.bind(this);
    this.getDCityList = this.getDCityList.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.setImage = this.setImage.bind(this);
    this.setImageAadharDoc2 = this.setImageAadharDoc2.bind(this);
    this.setImagePath2 = this.setImagePath2.bind(this);
    this.setImagePathAccountHolder = this.setImagePathAccountHolder.bind(this);
    this.setImagePathAccountHolder2 =
      this.setImagePathAccountHolder2.bind(this);
    this.setImagePathAccountHolder3 =
      this.setImagePathAccountHolder3.bind(this);
    this.setImagePathAccountHolder4 =
      this.setImagePathAccountHolder4.bind(this);
    this.setImagePathAccountHolder5 =
      this.setImagePathAccountHolder5.bind(this);

    this.setImage1 = this.setImage1.bind(this);

    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.resetFormError = this.resetFormError.bind(this);

    this.state = {
      FromDate: new Date(),
      ToDate: new Date(),
      IsAdd: true,
      IsEdit: true,
      first: 0,
      isImage: false,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      sortOrder: "",
      buttonLabel: "Submit",
      switchAction: false,
      formHeading: "Add Dealer Master",
      selectedUserType: "",
      searchText: "",
      userFilterData: [
        { label: "All", value: "" },
        { label: "Salesperson", value: "Salesperson" },
        { label: "Contractor", value: "Contractor" },
        { label: "Dealer", value: "Dealer" },
        { label: "HHT-Distributor", value: "HHT-Distributor" },
        { label: "Sub_Dealer", value: "Sub_Dealer" },
        { label: "Architect", value: "Architect" },
      ],

      // CSV Export Headers
      headers: [
        { label: "User Name", key: "UserName" },
        { label: "User Type", key: "RoleName" },
        { label: "Email", key: "Email" },
        { label: "Mobile Number", key: "MobileNo" },
        { label: "State", key: "StateName" },
        { label: "City", key: "CityName" },
        { label: "Pincode", key: "Pincode" },
        { label: "PAN Number", key: "PanNo" },
        { label: "GST Number", key: "GstNo" },
        { label: "Aadhar Number", key: "AadharNo" },
        { label: "Document Number", key: "DocumentNo" },
        { label: "Status", key: "IsActive" },
        { label: "Created Date", key: "CreatedDate" },
      ],

      GstCertificate: "",
      AadharDoc1: "",
      AadharDoc2: "",
      PanNoDoc: "",
      CounterDoc: "",
      DealerId: 0,
      pdf: "",
      gstPdf: "",
      RoleId: "",
      PanNo: "",
      AadharNo: "",
      UpiAddress: "",
      IfscCode: "",
      BankName: "",
      Branch: "",
      AccountNo: "",
      WorkshopName: "",
      District: 0,
      RegisterdBySalesId: "",
      Address: "",
      BillingSameAsShipping: false,
      CityId: 0,
      isEditing: false,
      compId: 0,
      NameOfBussiness: "",
      LandlineNo: "",
      CreditDays: "",
      PaymentMode: "",
      CompanyTypeId: 0,
      DOB: "",
      CreditLimit: 0,
      TurnoverPA: "",
      SecurityChequeNo: "",
      ResStateId: "",
      ResCityId: "",
      Respincode: "",
      ResAddress: "",
      Rescountry: "",
      UserTypeId: "",
      TransportationModeId: 0,
      CountryData: [{ value: 1, label: "India" }],
      UserFirmData: [],
      DocumentTypes: [],
      UserPayMentData: [],
      DealerName: "",
      FirmName: "",
      DistFirmName: "",
      UserName: "",
      CompanyName: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      OriginalPassword: "",
      Nature_Firm: "",
      GstNo: "",
      GstCertificate: "",
      RegisterdBySalesId: "",
      DocumentType: "",
      address: "",
      Pincode: "",
      country: "",
      state: "",
      city: "",
      CityBill: [],
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      AdminUserId: 0,
      formError: {
        PanNo: "",
        AadharNo: "",
        UpiAddress: "",
        IfscCode: "",
        BankName: "",
        Branch: "",
        AccountNo: "",
        WorkshopName: "",
        District: "",
        FirmName: "",
        DistFirmName: "",
        UserName: "",
        CompanyName: "",
        UserTypeId: "",
        RegisterdBySalesId: "",
        Address: "",
        DocumentType: "",
        country: "",
        state: "",
        city: "",
        Pincode: "",
        GstCertificate: "",
        AadharDoc1: "",
        AadharDoc2: "",
        PanNoDoc: "",
        CounterDoc: "",
        GstNo: "",
        Email: "",
        MobileNo: "",
        Password: "",
        ConfirmPassword: "",
        RoleId: "",
        CityId: "",
        TransportationModeId: "",
        ResStateId: "",
        ResCityId: "",
        Respincode: "",
        ResAddress: "",
      },

      // AddressFirm: this.state.AddressFirm,
      // pincode: this.state.pincode,       // lowercase — matches API param

      //Respincode: this.state.Respincode,
      //ResPhoneNo: this.state.ResPhoneNo,
      //ResStateId: this.state.ResStateId,
      //ResCityId: this.state.ResCityId,

      //NameOfBussiness: this.state.NameOfBussiness,
      //ResAddress: this.state.ResAddress,
      //DOB: this.state.DOB,
      //LandlineNo: this.state.LandlineNo,
      //PaymentMode: this.state.PaymentMode,
      //CompanyTypeId: this.state.CompanyTypeId,
      //CreditLimit: this.state.CreditLimit,
      //CreditDays: this.state.CreditDays,
      //TurnoverPA: this.state.TurnoverPA,
      //SecurityChequeNo: this.state.SecurityChequeNo,
      //UpdatedBy: this.state.AdminUserId,

      RoleId: "",
      AddressFirm: "",
      pincode: "",
      ResPhoneNo: "",

      AccountHolderImg: "",
      ChequeImage: "",
      ResAddressDoc1: "",
      ResAddressDoc2: "",
      CounterDoc: "",

      //showDistributorSection: false,
      showDistributorSection: false,
      DistributorId: "", // which distributor this dealer belongs to
      DistributorDDL: [],
      CompanyTypes: [
        {
          label: "Proprietorship",
          value: "1",
        },
        {
          label: "Partnership",
          value: "2",
        },
        {
          label: "Pvt Ltd",
          value: "3",
        },
      ],

      DistributorId: "", // ← add to state
      DistributorDDL: [], // ← local fallback (or use from props)
    };
  }

  ViewGST = (e) => {
    e.preventDefault();
    this.setState({ showIframe: true });
  };

  handleOpenModal = (e) => {
    e.preventDefault();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount() {
    this.props.getFirmDDL();
    this.props.GETPAYMENTDDL();
    this.props.GETDOCUMENTTYPEDDL();
    this.props.GetSalesPersonDDL();

    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const AdminUserId = userData ? parseInt(userData, 10) : 0;
    this.setState({ AdminUserId });
    this.props.GetDistributorByUserId(AdminUserId); // ← ADD THIS LINE
    setTimeout(() => {
      console.log("Distributor Props:", this.props.DistributorDDL);
    }, 3000);
    var date = new Date();

    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 30);
    this.tblResponse.FromDate = formatApiDateTime(date);
    this.tblResponse.ToDate = formatApiDateTime(new Date());
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        } else {
          this.setState({
            IsAdd: true,
          });
        }
      }
    }

    this.props.fetchApi(this.tblResponse);
    this.props.getRoleDDL(2);
    this.props.exportData(this.tblResponse);
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  resetFormError() {
    this.setState({
      formError: {
        UpiAddress: "",
        IfscCode: "",
        BankName: "",
        Branch: "",
        AccountNo: "",
        UserName: "",
        CompanyName: "",
        UserTypeId: "",
        AccountHolderImg: "",
        ChequeImage: "",
        ResAddressDoc1: "",
        ResAddressDoc2: "",
        CounterDoc: "",
        PanNoDoc: "",
        DocumentNo: "",
        DocumentType: "",
        RegisterdBySalesId: "",
        Address: "",
        DocumentType: "",
        country: "",
        state: "",
        city: "",
        Pincode: "",
        PanNo: "",
        PanNoDoc: "",
        AadharNo: "",
        GstCertificate: "",
        AadharDoc1: "",
        AadharDoc2: "",
        GstNo: "",
        Email: "",
        MobileNo: "",
        Password: "",
        ConfirmPassword: "",
        RoleId: "",
        CityId: "",
        NameOfBussiness: "",
        DOB: "",
        LandlineNo: "",
        PaymentMode: "",
        CompanyTypeId: "",
        ResStateId: "",
        CreditLimit: "",
        ResCityId: "",
        Respincode: "",
        CreditDays: "",
        TurnoverPA: "",
        ResAddress: "",
        SecurityChequeNo: "",

        DistributorId: "",
      },
    });
  }

  setImagePath(event) {
    let errors = this.state.formError;
    errors.GstCertificate = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();

        if (fileName.endsWith(".pdf")) {
          this.setState({
            GstCertificate: response.Source,
            gstPdf: event.files[0].name,
          });
        } else {
          errors.GstCertificate = "Only PDF format is accepted.";
          this.setState({ GstCertificate: "", gstPdf: "" });
        }
      }
    }
    this.setState({ formError: errors });
  }

  setImagePathAccountHolder(event) {
    let errors = this.state.formError;
    errors.AccountHolderImg = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();
        if (
          fileName.endsWith(".jpg") ||
          fileName.endsWith(".jpeg") ||
          fileName.endsWith(".png")
        ) {
          this.setState({
            AccountHolderImg: response.Source,
            pdf: "",
            isImage: true,
          });
        } else {
          errors.AccountHolderImg =
            "Only image formats (JPG, PNG) are accepted.";
          this.setState({ AccountHolderImg: "", pdf: "" });
        }
      } else {
        errors.AccountHolderImg = "File upload failed.";
      }
    } else {
      errors.AccountHolderImg = "Something went wrong.";
    }

    this.setState({ formError: errors });
  }

  setImagePathAccountHolder2(event) {
    let errors = this.state.formError;
    errors.ChequeImage = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();
        if (
          fileName.endsWith(".jpg") ||
          fileName.endsWith(".jpeg") ||
          fileName.endsWith(".png")
        ) {
          this.setState({
            ChequeImage: response.Source,
            pdf: "",
            isImage: true,
          });
        } else {
          errors.ChequeImage = "Only image formats (JPG, PNG) are accepted.";
          this.setState({ ChequeImage: "", pdf: "" });
        }
      } else {
        errors.ChequeImage = "File upload failed.";
      }
    } else {
      errors.ChequeImage = "Something went wrong.";
    }

    this.setState({ formError: errors });
  }

  setImagePathAccountHolder3(event) {
    let errors = this.state.formError;
    errors.ResAddressDoc1 = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();
        if (
          fileName.endsWith(".jpg") ||
          fileName.endsWith(".jpeg") ||
          fileName.endsWith(".png")
        ) {
          this.setState({
            ResAddressDoc1: response.Source,
            pdf: "",
            isImage: true,
          });
        } else {
          errors.ResAddressDoc1 = "Only image formats (JPG, PNG) are accepted.";
          this.setState({ ResAddressDoc1: "", pdf: "" });
        }
      } else {
        errors.ResAddressDoc1 = "File upload failed.";
      }
    } else {
      errors.ResAddressDoc1 = "Something went wrong.";
    }

    this.setState({ formError: errors });
  }

  setImagePathAccountHolder4(event) {
    let errors = this.state.formError;
    errors.ResAddressDoc1 = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();
        if (
          fileName.endsWith(".jpg") ||
          fileName.endsWith(".jpeg") ||
          fileName.endsWith(".png")
        ) {
          this.setState({
            ResAddressDoc2: response.Source,
            pdf: "",
            isImage: true,
          });
        } else {
          errors.ResAddressDoc2 = "Only image formats (JPG, PNG) are accepted.";
          this.setState({ ResAddressDoc2: "", pdf: "" });
        }
      } else {
        errors.ResAddressDoc2 = "File upload failed.";
      }
    } else {
      errors.ResAddressDoc2 = "Something went wrong.";
    }

    this.setState({ formError: errors });
  }

  setImagePathAccountHolder5(event) {
    let errors = this.state.formError;
    errors.CounterDoc = "";

    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response && response.ResponseCode === "200") {
        const fileName = event.files[0].name.toLowerCase();
        if (
          fileName.endsWith(".jpg") ||
          fileName.endsWith(".jpeg") ||
          fileName.endsWith(".png")
        ) {
          this.setState({
            CounterDoc: response.Source,
            pdf: "",
            isImage: true,
          });
        } else {
          errors.CounterDoc = "Only image formats (JPG, PNG) are accepted.";
          this.setState({ CounterDoc: "", pdf: "" });
        }
      } else {
        errors.CounterDoc = "File upload failed.";
      }
    } else {
      errors.CounterDoc = "Something went wrong.";
    }

    this.setState({ formError: errors });
  }

  setImage(event) {
    let errors = this.state.formError;

    errors.AadharDoc1 = "";

    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              AadharDoc1: response.Source,
              pdf: "",
              isImage: true,
            });
            if (response.Source.toString().includes(".pdf")) {
              this.setState({
                pdf: event.files[0].name,
                isImage: false,
              });
            }
          } else if (response.ResponseCode === "400") {
            errors.AadharDoc1 = "Only image format is accepted.";
            this.setState({
              AadharDoc1: "",
            });
          }
        }
      }
    }
  }

  setImageAadharDoc2(event) {
    let errors = this.state.formError;

    errors.AadharDoc2 = "";

    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              AadharDoc2: response.Source,
              pdf: "",
              isImage: true,
            });
            if (response.Source.toString().includes(".pdf")) {
              this.setState({
                pdf: event.files[0].name,
                isImage: false,
              });
            }
          } else if (response.ResponseCode === "400") {
            errors.AadharDoc2 = "Only image format is accepted.";
            this.setState({
              AadharDoc2: "",
            });
          }
        }
      }
    }
  }

  setImage1(event) {
    let errors = this.state.formError;

    errors.CounterDoc = "";

    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              CounterDoc: response.Source,
              pdf: "",
              isImage: true,
            });
            if (response.Source.toString().includes(".pdf")) {
              this.setState({
                pdf: event.files[0].name,
                isImage: false,
              });
            }
          } else if (response.ResponseCode === "400") {
            errors.CounterDoc = "Only image format is accepted.";
            this.setState({
              CounterDoc: "",
            });
          }
        }
      }
    }
  }

  setImagePath2(event) {
    let errors = this.state.formError;

    errors.PanNoDoc = "";

    if (event.xhr) {
      if (event.xhr.response) {
        const response = JSON.parse(event.xhr.response);
        if (response) {
          if (response.ResponseCode === "200") {
            this.setState({
              PanNoDoc: response.Source,
              pdf: "",
              isImage: true,
            });
            if (response.Source.toString().includes(".pdf")) {
              this.setState({
                pdf: event.files[0].name,
                isImage: false,
              });
            }
          } else if (response.ResponseCode === "400") {
            errors.PanNoDoc = "Only image format is accepted.";
            this.setState({
              PanNoDoc: "",
            });
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.UserData) {
      if (prevProps.UserData !== this.props.UserData) {
        if (this.props.UserData) {
          console.log("User Data", this.props.UserData);
          var e = this.props.UserData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }
  }

  handleCheckboxChange = (rowData, checked) => {
    const newStatus = checked ? 1 : 0;

    const confirmMsg = `Are you sure you want to ${
      newStatus === 1 ? "grant" : "remove"
    } Cash Payment permission to this Dealer?`;

    if (!window.confirm(confirmMsg)) {
      return;
    }

    this.props
      .updatePaymentStatus(rowData.UserId, newStatus)
      .then(() => {
        this.props.fetchApi(this.tblResponse);
      })
      .catch((err) => {
        console.error("Payment update failed:", err);
      });
  };

  switchToggleConfirm = (e) => {
    this.props.inActiveRow(this.state.UserId, this.state.switchAction);
  };

  async handleChange(event) {
    console.log("Event in handleChange:", event);
    let name = "";
    let value = "";

    if (event.target) {
      name = event.target.name;
      value = event.target.value;
    } else {
      name = event.name;
      value = event.value;
    }

    let errors = this.state.formError;

    if (name === "IsActive") {
      value = event.target.checked;
    }

    this.validateForm(value, name);

    this.setState(
      {
        [name]: value,
        formError: errors,
      },
      () => {
        if (name === "FromDate" || name === "ToDate") {
          clearTimeout(this.searchTimeout);
          this.setState({ first: 0 });
          Object.assign(this.tblResponse, {
            PageNo: 1,
            PageSize: this.state.rows,
            First: 1,
            SearchValue:
              this.state.searchText || this.state.selectedUserType || "",
            FromDate: formatApiDateTime(this.state.FromDate),
            ToDate: formatApiDateTime(this.state.ToDate),
          });
          this.props.loadingData(true);
          this.props.fetchApi({ ...this.tblResponse });
        }

        if (name === "RoleId" && value === "5") {
          const userData = JSON.parse(sessionStorage.getItem("UserData"));
          const AdminUserId = userData ? parseInt(userData, 10) : 0;

          console.log("Calling Distributor API with:", AdminUserId);

          this.props.GetDistributorByUserId(AdminUserId);
        }
      },
    );

    if (name === "IfscCode" && value.length === 11) {
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${value}`);

        if (!response.ok) throw new Error();

        const data = await response.json();

        this.setState({
          BankName: data.BANK,
          Branch: data.BRANCH,
        });
      } catch {
        this.setState({
          BankName: "",
          Branch: "",
        });
      }
    }
  }
  // async handleChange(event, type) {
  //   let { name, value } = event.target;
  //   let errors = this.state.formError;
  //   switch (name) {
  //     case "IsActive":
  //       value = event.target.checked;
  //       break;
  //     default:
  //       break;
  //   }
  //   this.validateForm(value, name);
  //   this.setState({ errors, [name]: value });

  //   if (name === "IfscCode" && value.length === 11) {
  //     try {
  //       const response = await fetch(`https://ifsc.razorpay.com/${value}`);
  //       if (!response.ok) {
  //         throw new Error("Invalid IFSC Code");
  //       }
  //       const data = await response.json();
  //       this.setState({ Branch: data.BRANCH, BankName: data.BANK });
  //     } catch (error) {
  //       this.setState({ Branch: "" });
  //     }
  //   }
  // }

  dhandleChange(event, type) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    switch (name) {
      case "IsActive":
        value = event.target.checked;
        break;

      default:
        break;
    }
    this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }

  handleChangeDate(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select from date.",
            life: 3000,
          });
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "From date must be less than to date.",
              life: 3000,
            });
            return;
          }
        }
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select to date.",
            life: 3000,
          });
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000,
          });
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "To date must be greater than from date.",
              life: 3000,
            });
            return;
          }
        }
        break;
      default:
        break;
    }

    this.setState({ [name]: value });
  }

  getDStateList(event, type) {
    if (type == "De") {
      this.setState({ country: event.target.value });
      this.props.getDStateDDL(event.target.value);
    }
  }

  getStateList(event, type) {
    if (type == "B") {
      this.setState({ country: event.target.value.toString() });
      this.props.getStateDDL(event.target.value);
    }
  }

  getCityList(event, type, flag) {
    if (flag == "i") {
      if (type == "B") {
        this.setState({ state: event.target.value });
        this.props.getBCityDDL(event.target.value);
      }
    } else {
      if (type == "B") {
        this.setState({ state: event });
        this.props.getBCityDDL(event);
      }
    }
  }

  getDCityList(event, type, flag) {
    if (flag == "Z") {
      if (type == "CI") {
        this.setState({ ResStateId: event.target.value });
        this.props.getDCityDDL(event.target.value);
      }
    } else {
      if (type == "CI") {
        this.setState({ ResStateId: event });
        this.props.getDCityDDL(event);
      }
    }
  }

  getFirmList(event) {
    this.props.getFirmDDL();
  }

  GetPaymentDDL(event) {
    this.props.GETPAYMENTDDL();
  }

  GetDocumentTypeDDl() {
    this.props.GETDOCUMENTTYPEDDL();
  }

  GetALLSalesPersonList() {
    this.props.GetSalesPersonDDL();
  }

  UpdatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  CreatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;

    // ✅ ADD THIS — for distributor, only validate the common fields
    // Fields with no case in switch return true already, so this just
    // prevents role-specific cases (RoleId 5/2/3) from firing on RoleId 9
    const isDistributor = this.state.RoleId === "9";

    switch (name) {
      case "UserName":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.UserName = "Please enter User Name.";
        } else errors.UserName = "";
        break;

      case "Email":
        // ✅ FIXED original bug: value.length < 1 crashes if value is undefined
        if (!value || value.length < 1) {
          IsValid = false;
          errors.Email = "Please enter email-id.";
        } else if (
          !value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
        ) {
          IsValid = false;
          errors.Email = "Please enter valid email-id.";
        } else errors.Email = "";
        break;

      case "MobileNo":
        // ✅ FIXED: original `!value && value.length < 1` never triggers
        if (!value || value.length < 1) {
          IsValid = false;
          errors.MobileNo = "Please enter mobile no.";
        } else if (!value.match(/^[6-9]\d{9}$/)) {
          IsValid = false;
          errors.MobileNo = "Please enter valid mobile no.";
        } else errors.MobileNo = "";
        break;

      case "Password":
        // ✅ FIXED: original `!value && value.length < 1` never triggers
        if (!value || value.length < 1) {
          IsValid = false;
          errors.Password = "Please enter password.";
        } else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
          IsValid = false;
          errors.Password =
            "Password should be minimum 4 characters, 1 uppercase & 1 lowercase with 1 number.";
        } else errors.Password = "";
        break;

      case "ConfirmPassword":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.ConfirmPassword = "Please enter confirm password.";
        } else if (value !== this.state.Password) {
          IsValid = false;
          errors.ConfirmPassword =
            "New password and Confirm password should be same.";
        } else errors.ConfirmPassword = "";
        break;

      // ✅ For distributor, skip all role-specific validations below
      case "ResStateId":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResStateId = "Please select State";
        } else errors.ResStateId = "";
        break;

      case "ResCityId":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResCityId = "Please select City";
        } else errors.ResCityId = "";
        break;

      case "Respincode":
        if (this.state.RoleId == 5) {
          if (!value || value.length !== 6 || !/^\d{6}$/.test(value)) {
            errors.Respincode = "Please enter valid 6-digit Pincode";
            IsValid = false;
          } else errors.Respincode = "";
        } else errors.Respincode = "";
        break;

      case "ResAddress":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResAddress = "Please enter Address";
        } else errors.ResAddress = "";
        break;

      case "ResPhoneNo":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResPhoneNo = "Please enter Phone Number";
        } else errors.ResPhoneNo = "";
        break;

      case "state":
        if (
          !value &&
          (this.state.RoleId == 5 ||
            this.state.RoleId == 2 ||
            this.state.RoleId == 3)
        ) {
          IsValid = false;
          errors.state = "Please select state";
        } else errors.state = "";
        break;

      case "city":
        if (!value && ["2", "3", "5"].includes(this.state.RoleId)) {
          IsValid = false;
          errors.city =
            this.state.RoleId === "3"
              ? "Please select Zone"
              : "Please select City";
        } else errors.city = "";
        break;

      case "country":
        if (
          !value &&
          (this.state.RoleId == 5 ||
            this.state.RoleId == 2 ||
            this.state.RoleId == 3)
        ) {
          IsValid = false;
          errors.country = "Please select Country";
        } else errors.country = "";
        break;

      case "Pincode":
        if (
          this.state.RoleId == 5 ||
          this.state.RoleId == 2 ||
          this.state.RoleId == 3
        ) {
          if (!value || value.length !== 6 || !/^\d{6}$/.test(value)) {
            errors.Pincode = "Please enter valid 6-digit Pincode";
            IsValid = false;
          } else errors.Pincode = "";
        } else errors.Pincode = "";
        break;

      case "Address":
        if (
          !value &&
          (this.state.RoleId == 5 ||
            this.state.RoleId == 2 ||
            this.state.RoleId == 3)
        ) {
          IsValid = false;
          errors.Address = "Please Enter Address";
        } else errors.Address = "";
        break;

      case "GstNo":
        var gstFormat = new RegExp(
          "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",
        );
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.GstNo = "Please enter GST Number.";
        } else if (value && !gstFormat.test(value) && !isDistributor) {
          IsValid = false;
          errors.GstNo = "GST Number is not valid.";
        } else errors.GstNo = "";
        break;

      case "GstCertificate":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.GstCertificate = "Please Upload GST Certificate.";
        } else errors.GstCertificate = "";
        break;

      case "PanNo":
        var panFormat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");
        if (this.state.RoleId == 2) {
          errors.PanNo = "";
          break;
        }
        if (!value && (this.state.RoleId == 3 || this.state.RoleId == 5)) {
          IsValid = false;
          errors.PanNo = "Please enter PAN Number.";
        } else if (value && !panFormat.test(value) && !isDistributor) {
          IsValid = false;
          errors.PanNo = "PAN Number is not valid.";
        } else errors.PanNo = "";
        break;

      case "PanNoDoc":
        if (!value && (this.state.RoleId == 3 || this.state.RoleId == 5)) {
          IsValid = false;
          errors.PanNoDoc = "Please Upload PAN Card Image.";
        } else errors.PanNoDoc = "";
        break;

      case "AadharDoc1":
        if (!value && this.state.RoleId == 3) {
          IsValid = false;
          errors.AadharDoc1 = "Please Upload Aadhar Front Image.";
        } else if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.AadharDoc1 = "Please Upload Document Front Image.";
        } else errors.AadharDoc1 = "";
        break;

      case "AadharDoc2":
        if (!value && this.state.RoleId == 3) {
          IsValid = false;
          errors.AadharDoc2 = "Please Upload Aadhar Back Image.";
        } else if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.AadharDoc2 = "Please Upload Document Back Image.";
        } else errors.AadharDoc2 = "";
        break;

      case "DocumentType":
        if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.DocumentType = "Please Select Document Type";
        } else errors.DocumentType = "";
        break;

      case "RegisterdBySalesId":
        if (!value && (this.state.RoleId == 2 || this.state.RoleId == 5)) {
          IsValid = false;
          errors.RegisterdBySalesId = "Please Select Registerd By Sales Person";
        } else errors.RegisterdBySalesId = "";
        break;

      case "DocumentNo":
        if (this.state.RoleId === "3") {
          if (!value) {
            IsValid = false;
            errors.DocumentNo = "Please enter Aadhaar Number.";
          } else if (!/^\d{12}$/.test(value)) {
            IsValid = false;
            errors.DocumentNo = "Aadhaar Number must be exactly 12 digits.";
          } else errors.DocumentNo = "";
        } else if (this.state.RoleId === "2") {
          if (!value) {
            IsValid = false;
            errors.DocumentNo = "Please enter Document Number.";
          } else if (value.length > 20) {
            IsValid = false;
            errors.DocumentNo = "Please enter a valid document number.";
          } else errors.DocumentNo = "";
        } else errors.DocumentNo = "";
        break;

      case "IfscCode":
        if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.IfscCode = "Please Select IFSC Code";
        } else errors.IfscCode = "";
        break;

      case "AccountNo":
        if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.AccountNo = "Please Enter Account No";
        } else errors.AccountNo = "";
        break;

      case "BankName":
        if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.BankName = "Please Enter Bank Name";
        } else errors.BankName = "";
        break;

      case "Branch":
        if (!value && this.state.RoleId == 2) {
          IsValid = false;
          errors.Branch = "Please Enter Branch Name";
        } else errors.Branch = "";
        break;

      case "AccountHolderImg":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.AccountHolderImg = "Please upload Account Holder Image";
        } else errors.AccountHolderImg = "";
        break;

      case "ChequeImage":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ChequeImage = "Please upload Cheque Image";
        } else errors.ChequeImage = "";
        break;

      case "ResAddressDoc1":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResAddressDoc1 = "Please upload ResAddress Front Image";
        } else errors.ResAddressDoc1 = "";
        break;

      case "ResAddressDoc2":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.ResAddressDoc2 = "Please upload ResAddress Back Image";
        } else errors.ResAddressDoc2 = "";
        break;

      case "CounterDoc":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.CounterDoc = "Please upload Counter Image";
        } else errors.CounterDoc = "";
        break;

      case "NameOfBussiness":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.NameOfBussiness = "Please enter Business Name";
        } else errors.NameOfBussiness = "";
        break;

      case "DOB":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.DOB = "Please enter Date of Birth";
        } else errors.DOB = "";
        break;

      case "PaymentMode":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.PaymentMode = "Please select Payment Mode";
        } else errors.PaymentMode = "";
        break;

      case "CompanyTypeId":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.CompanyTypeId = "Please select Company Type";
        } else errors.CompanyTypeId = "";
        break;

      case "CreditLimit":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.CreditLimit = "Please enter Credit Limit";
        } else errors.CreditLimit = "";
        break;

      case "CreditDays":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.CreditDays = "Please enter Credit Days";
        } else errors.CreditDays = "";
        break;

      case "TurnoverPA":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.TurnoverPA = "Please enter Annual Turnover";
        } else errors.TurnoverPA = "";
        break;

      case "SecurityChequeNo":
        if (!value && this.state.RoleId == 5) {
          IsValid = false;
          errors.SecurityChequeNo = "Please enter Security Cheque Number";
        } else errors.SecurityChequeNo = "";
        break;

      case "LandLineNo":
      case "LandlineNo":
        errors.LandlineNo = "";
        break;

      default:
        break;
    }

    return IsValid;
  }
  // validateForm(value, name) {
  //   let errors = this.state.formError;
  //   let IsValid = true;
  //   switch (name) {
  //     case "UserName":
  //       if (!value || value.length < 1) {
  //         IsValid = false;
  //         errors.UserName = "Please enter User Name.";
  //       } else errors.UserName = "";
  //       break;

  //     case "AadharDoc1":
  //       if (!value && this.state.RoleId == 3) {
  //         IsValid = false;
  //         errors.AadharDoc1 = "Please Upload Aadhar Front Image.";
  //       } else errors.AadharDoc1 = "";

  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.AadharDoc1 = "Please Upload Document Front Image.";
  //       } else errors.AadharDoc1 = "";
  //       break;

  //     case "AadharDoc2":
  //       if (!value && this.state.RoleId == 3) {
  //         IsValid = false;
  //         errors.AadharDoc2 = "Please Upload Aadhar Back Image.";
  //       } else errors.AadharDoc2 = "";
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.AadharDoc2 = "Please Upload Document Back Image.";
  //       } else errors.AadharDoc2 = "";
  //       break;

  //     case "PanNoDoc":
  //       if (!value && (this.state.RoleId == 3 || this.state.RoleId == 5)) {
  //         IsValid = false;
  //         errors.PanNoDoc = "Please Upload PAN Card Image.";
  //       } else errors.PanNoDoc = "";
  //       break;

  //     case "Email":
  //       if (value.length < 1) {
  //         IsValid = false;
  //         errors.Email = "Please enter email-id.";
  //       } else if (value.length >= 1) {
  //         if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
  //           IsValid = false;
  //           errors.Email = "Please enter valid email-id.";
  //         } else errors.Email = "";
  //       } else errors.Email = "";
  //       break;
  //     case "MobileNo":
  //       if (!value && value.length < 1) {
  //         IsValid = false;
  //         errors.MobileNo = "Please enter mobile no.";
  //       } else if (!value && value.length >= 1) {
  //         if (!value.match(/^[6-9]\d{9}$/)) {
  //           IsValid = true;
  //           errors.MobileNo = "Please enter valid mobile no.";
  //         } else errors.MobileNo = "";
  //       } else errors.MobileNo = "";
  //       break;
  //     case "Password":
  //       if (!value && value.length < 1) {
  //         IsValid = false;
  //         errors.Password = "Please enter password.";
  //       } else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
  //         IsValid = false;
  //         errors.Password =
  //           "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
  //       } else if (
  //         !value &&
  //         value.length >= 1 &&
  //         this.state.ConfirmPassword.length >= 1
  //       ) {
  //         errors.Password = "";
  //         errors.ConfirmPassword = "";
  //         if (!(value === this.state.ConfirmPassword)) {
  //           IsValid = false;
  //           errors.Password = "password does not match";
  //         } else errors.Password = "";
  //       } else errors.Password = "";
  //       break;

  //     case "ConfirmPassword":
  //       if (!value && value.length < 1) {
  //         IsValid = false;
  //         errors.ConfirmPassword = "Please enter confirm password.";
  //       } else if (
  //         !value &&
  //         value.length >= 1 &&
  //         this.state.Password.length >= 1
  //       ) {
  //         errors.Password = "";
  //         errors.ConfirmPassword = "";
  //         if (value !== this.state.Password) {
  //           IsValid = false;
  //           errors.ConfirmPassword =
  //             "New password and Confirm password should be same.";
  //         }
  //       } else if (
  //         !value &&
  //         value.length >= 1 &&
  //         this.state.Password.length >= 1
  //       ) {
  //         errors.Password = "";
  //         errors.ConfirmPassword = "";
  //         if (!(value === this.state.Password)) {
  //           IsValid = false;
  //           errors.ConfirmPassword = "Confirm password does not match";
  //         } else errors.ConfirmPassword = "";
  //       } else errors.ConfirmPassword = "";
  //       break;

  //     case "city":
  //       if (!value && ["2", "3", "5"].includes(this.state.RoleId)) {
  //         IsValid = false;
  //         errors.city =
  //           this.state.RoleId === "3"
  //             ? "Please select Zone"
  //             : "Please select City";
  //       } else {
  //         errors.city = "";
  //       }
  //       break;

  //     case "state":
  //       if (
  //         !value &&
  //         (this.state.RoleId == 5 ||
  //           this.state.RoleId == 2 ||
  //           this.state.RoleId == 3)
  //       ) {
  //         IsValid = false;
  //         errors.state = "Please select state";
  //       } else {
  //         errors.state = "";
  //       }
  //       break;

  //     case "GstNo":
  //       var gstFormat = new RegExp(
  //         "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
  //       );

  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.GstNo = "Please enter GST Number.";
  //       } else if (value && !gstFormat.test(value)) {
  //         IsValid = false;
  //         errors.GstNo =
  //           "GST Identification Number is not valid. It should be in this format: 11AAAAA1111Z1A1.";
  //       } else {
  //         errors.GstNo = "";
  //       }
  //       break;

  //     case "GstCertificate":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.GstCertificate = "Please Upload GST Certificate.";
  //       } else errors.GstCertificate = "";
  //       break;

  //     case "PanNo":
  //       var panFormat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

  //       if (this.state.RoleId == 2) {
  //         errors.PanNo = "";
  //         break;
  //       }

  //       if (!value && (this.state.RoleId == 3 || this.state.RoleId == 5)) {
  //         IsValid = false;
  //         errors.PanNo = "Please enter PAN Number.";
  //       }
  //       else if (value && !panFormat.test(value)) {
  //         IsValid = false;
  //         errors.PanNo =
  //           "PAN Number is not valid. It should be in this format: AAAAA1111A";
  //       }
  //       else {
  //         errors.PanNo = "";
  //       }
  //       break;

  //     case "Address":
  //       if (
  //         !value &&
  //         (this.state.RoleId == 5 ||
  //           this.state.RoleId == 2 ||
  //           this.state.RoleId == 3)
  //       ) {
  //         IsValid = false;
  //         errors.Address = "Please Enter Address";
  //       } else {
  //         errors.Address = "";
  //       }
  //       break;

  //     case "DocumentType":
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.DocumentType = "Please Select Document Type";
  //       } else {
  //         errors.DocumentType = "";
  //       }
  //       break;
  //     case "RegisterdBySalesId":
  //       if (!value && (this.state.RoleId == 2 || this.state.RoleId == 5)) {
  //         IsValid = false;
  //         errors.RegisterdBySalesId = "Please Select Registerd By Sales Person";
  //       } else {
  //         errors.RegisterdBySalesId = "";
  //       }
  //       break;

  //     case "DocumentNo":
  //       if (this.state.RoleId === "3") {
  //         if (!value) {
  //           IsValid = false;
  //           errors.DocumentNo = "Please enter Aadhaar Number.";
  //         } else if (!/^\d{12}$/.test(value)) {
  //           IsValid = false;
  //           errors.DocumentNo = "Aadhaar Number must be exactly 12 digits.";
  //         } else {
  //           errors.DocumentNo = "";
  //         }
  //       }

  //       if (this.state.RoleId === "2") {
  //         if (!value) {
  //           IsValid = false;
  //           errors.DocumentNo = "Please enter Document Number.";
  //         } else if (value.length > 20) {
  //           IsValid = false;
  //           errors.DocumentNo =
  //             //"Aadhaar Number must be between 5 and 12 digits.";
  //             "Please enter a valid document number.";
  //         } else {
  //           errors.DocumentNo = "";
  //         }
  //       }
  //       break;

  //     case "IfscCode":
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.IfscCode = "Please Select IFSC Code";
  //       } else {
  //         errors.IfscCode = "";
  //       }
  //       break;

  //     case "AccountNo":
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.AccountNo = "Please Enter Account No ";
  //       } else {
  //         errors.AccountNo = "";
  //       }
  //       break;

  //     case "BankName":
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.BankName = "Please Enter Bank Name";
  //       } else {
  //         errors.BankName = "";
  //       }
  //       break;

  //     case "Branch":
  //       if (!value && this.state.RoleId == 2) {
  //         IsValid = false;
  //         errors.Branch = "Please Enter Branch Name";
  //       } else {
  //         errors.Branch = "";
  //       }
  //       break;

  //     case "Pincode":
  //       if (
  //         this.state.RoleId == 5 ||
  //         this.state.RoleId == 2 ||
  //         this.state.RoleId == 3
  //       ) {
  //         if (!value || value.length !== 6 || !/^\d{6}$/.test(value)) {
  //           errors.Pincode = "Please enter valid 6-digit Pincode";
  //           IsValid = false;
  //         } else {
  //           errors.Pincode = "";
  //         }
  //       }
  //       break;

  //     case "country":
  //       if (
  //         !value &&
  //         (this.state.RoleId == 5 ||
  //           this.state.RoleId == 2 ||
  //           this.state.RoleId == 3)
  //       ) {
  //         IsValid = false;
  //         errors.country = "Please select Country";
  //       } else errors.country = "";
  //       break;

  //     case "AccountHolderImg":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.AccountHolderImg = "Please upload Account Holder Image";
  //       } else errors.AccountHolderImg = "";
  //       break;
  //     case "ChequeImage":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ChequeImage = "Please upload Cheque Image";
  //       } else errors.ChequeImage = "";
  //       break;
  //     case "ResAddressDoc1":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResAddressDoc1 = "Please upload ResAddress Front Image";
  //       } else errors.ResAddressDoc1 = "";
  //       break;
  //     case "ResAddressDoc2":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResAddressDoc2 = "Please upload ResAddress Back Image";
  //       } else errors.ResAddressDoc2 = "";
  //       break;
  //     case "CounterDoc":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.CounterDoc = "Please upload Counter Image";
  //       } else errors.CounterDoc = "";
  //       break;
  //     case "Respincode":
  //       if (this.state.RoleId == 5) {
  //         if (!value || value.length !== 6 || !/^\d{6}$/.test(value)) {
  //           errors.Respincode = "Please enter valid 6-digit Pincode";
  //           IsValid = false;
  //         } else {
  //           errors.Respincode = "";
  //         }
  //       }
  //       break;

  //     case "ResPhoneNo":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResPhoneNo = "Please enter Phone Number";
  //       } else errors.ResPhoneNo = "";
  //       break;

  //     case "ResStateId":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResStateId = "Please select State";
  //       } else errors.ResStateId = "";
  //       break;

  //     case "ResCityId":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResCityId = "Please select City";
  //       } else errors.ResCityId = "";
  //       break;

  //     case "NameOfBussiness":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.NameOfBussiness = "Please enter Business Name";
  //       } else errors.NameOfBussiness = "";
  //       break;

  //     case "ResAddress":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.ResAddress = "Please enter Address";
  //       } else errors.ResAddress = "";
  //       break;

  //     case "DOB":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.DOB = "Please enter Date of Birth";
  //       } else errors.DOB = "";
  //       break;

  //     // case "LandlineNo":
  //     //   if (!value && this.state.RoleId == 5) {
  //     //     IsValid = false;
  //     //     errors.LandlineNo = "Please enter Landline Number";
  //     //   } else errors.LandlineNo = "";
  //     //   break;
  //     case "LandLineNo":
  //       errors.LandlineNo = "";
  //       IsValid = true;
  //       break;
  //     case "PaymentMode":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.PaymentMode = "Please select Payment Mode";
  //       } else errors.PaymentMode = "";
  //       break;

  //     case "CompanyTypeId":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.CompanyTypeId = "Please select Company Type";
  //       } else errors.CompanyTypeId = "";
  //       break;

  //     case "CreditLimit":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.CreditLimit = "Please enter Credit Limit";
  //       } else errors.CreditLimit = "";
  //       break;

  //     case "CreditDays":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.CreditDays = "Please enter Credit Days";
  //       } else errors.CreditDays = "";
  //       break;

  //     case "TurnoverPA":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.TurnoverPA = "Please enter Annual Turnover";
  //       } else errors.TurnoverPA = "";
  //       break;

  //     case "SecurityChequeNo":
  //       if (!value && this.state.RoleId == 5) {
  //         IsValid = false;
  //         errors.SecurityChequeNo = "Please enter Security Cheque Number";
  //       } else errors.SecurityChequeNo = "";
  //       break;

  //     default:
  //       break;
  //   }

  //   return IsValid;
  // }

  getDropValueOfRole() {
    let role = "";
    this.props.UserRoleData.filter((x) => {
      if (x.value === this.state.RoleId) {
        role = x.label;
      }
    });

    return role;
  }

  getDropValueOfCity() {
    let city = "";
    this.props.UserCityData.filter((x) => {
      if (x.value === this.state.CityId.toString()) {
        city = x.label;
      }
    });

    return city;
  }

  getDropValueOfUserType() {
    let usertype = "";
    this.state.CountryData.filter((x) => {
      if (x.value === this.state.Ship_Country) {
        usertype = x.label;
      }
    });

    return usertype;
  }

  // submitForm(event) {
  //   event.preventDefault();
  //   // ✅ ADD THIS DEBUG BLOCK FIRST
  //   console.log("=== SUBMIT FORM CALLED ===");
  //   console.log("RoleId:", this.state.RoleId);
  //   let isfrmvalid = true;
  //   let checkerror = this.state.formError;

  //   Object.entries(checkerror).map(([key, value]) => {
  //     const val = this.state[key];
  //     let valid = this.validateForm(val, key);
  //     if (!valid) {
  //       console.log("VALIDATION FAILED for key:", key, "| value:", val);
  //     }
  //     if (!valid) {
  //       this.setState({ checkerror: isfrmvalid });
  //       isfrmvalid = false;
  //     }
  //     return isfrmvalid;
  //   });
  //   console.log("Form valid:", isfrmvalid);
  //   if (isfrmvalid) {
  //     const formData = {
  //       UserId: this.state.UserId,
  //       UserType: "2",
  //       RoleId: this.state.RoleId,
  //       UserName: this.state.UserName,
  //       Email: this.state.Email,
  //       MobileNo: this.state.MobileNo,
  //       Password: this.state.Password,
  //       IsActive: this.state.IsActive,
  //       CreatedDate:
  //         this.state.DealerId > 0
  //           ? this.state.CreatedDate
  //           : this.getCurrentDateMMDDYYY(),
  //       UpdatedDate:
  //         this.state.DealerId > 0 ? this.getCurrentDateMMDDYYY() : null,
  //       DealerId: this.state.DealerId,

  //       UpiAddress: this.state.UpiAddress,
  //       IfscCode: this.state.IfscCode,
  //       BankName: this.state.BankName,
  //       Branch: this.state.Branch,
  //       AccountNo: this.state.AccountNo,

  //       PanNo: this.state.PanNo,
  //       PanNoDoc: this.state.PanNoDoc,
  //       AadharNo: this.state.AadharNo,
  //       AadharDoc1: this.state.AadharDoc1,
  //       AadharDoc2: this.state.AadharDoc2,
  //       DocumentNo: this.state.DocumentNo,
  //       DocumentType: this.state.DocumentType,
  //       RegisterdBySalesId: this.state.RegisterdBySalesId,
  //       GstNo: this.state.GstNo,
  //       GstCertificate: this.state.GstCertificate,
  //       AccountHolderImg: this.state.AccountHolderImg,
  //       ChequeImage: this.state.ChequeImage,
  //       ResAddressDoc1: this.state.ResAddressDoc1,
  //       ResAddressDoc2: this.state.ResAddressDoc2,
  //       CounterDoc: this.state.CounterDoc,
  //       Address: this.state.Address,
  //       Pincode: this.state.Pincode,
  //       country: this.state.country,
  //       state: this.state.state,
  //       city: this.state.city,

  //       Respincode: this.state.Respincode,
  //       ResPhoneNo: this.state.ResPhoneNo,
  //       ResStateId: this.state.ResStateId,
  //       ResCityId: this.state.ResCityId,

  //       NameOfBussiness: this.state.NameOfBussiness,
  //       ResAddress: this.state.ResAddress,
  //       DOB: this.state.DOB,
  //       LandlineNo: this.state.LandlineNo,
  //       PaymentMode: this.state.PaymentMode,
  //       CompanyTypeId: this.state.CompanyTypeId,
  //       CreditLimit: this.state.CreditLimit,
  //       CreditDays: this.state.CreditDays,
  //       TurnoverPA: this.state.TurnoverPA,
  //       SecurityChequeNo: this.state.SecurityChequeNo,
  //       UpdatedBy: this.state.AdminUserId,
  //       // Inside the formData object in submitForm, add these two lines:
  //       AddressFirm: this.state.AddressFirm,
  //       pincode: this.state.pincode,
  //     };
  //     if (formData.UserId > 0) {
  //       debugger;
  //       console.log("Update Data ", formData);
  //       this.props.updateDealer(formData, this.tblResponse);
  //       // this.props.fetchApi(this.tblResponse);
  //       setTimeout(() => {
  //         this.props.fetchApi(this.tblResponse);
  //       }, 1000);
  //     } else {

  //       console.log("Submitting Data:", formData);

  //       if (this.state.RoleId === "9") {
  //         //this.props.createDistributor(formData);
  //         this.props.createDistributor(formData, this.tblResponse);
  //       }
  //       else {
  //         this.props.createDealer(
  //           formData,
  //           this.tblResponse
  //         );
  //       }

  //       setTimeout(() => {
  //         this.props.fetchApi(this.tblResponse);
  //       }, 1000);

  //     }
  //   }
  // }
  submitForm(event) {
    event.preventDefault();

    let isfrmvalid = true;
    let checkerror = this.state.formError;
    const passwordUnchanged =
      this.state.isEditing &&
      this.state.Password === this.state.OriginalPassword &&
      this.state.ConfirmPassword === this.state.OriginalPassword;

    Object.entries(checkerror).map(([key, value]) => {
      if (
        passwordUnchanged &&
        (key === "Password" || key === "ConfirmPassword")
      ) {
        return true;
      }
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      const formData = {
        UserId: this.state.UserId,
        DealerId: this.state.DealerId,
        UserType: "2",
        RoleId: this.state.RoleId,
        UserName: this.state.UserName,
        Email: this.state.Email,
        MobileNo: this.state.MobileNo,
        Password: this.state.Password,
        IsActive: this.state.IsActive,
        CreatedDate:
          this.state.DealerId > 0
            ? this.state.CreatedDate
            : this.getCurrentDateMMDDYYY(),
        UpdatedDate:
          this.state.DealerId > 0 ? this.getCurrentDateMMDDYYY() : null,
        UpdatedBy: this.state.AdminUserId,

        NameOfBussiness: this.state.NameOfBussiness,
        AddressFirm: this.state.AddressFirm,
        Address: this.state.Address,
        state: this.state.state,
        city: this.state.city,
        pincode: this.state.Pincode || this.state.pincode || "",
        LandlineNo: this.state.LandlineNo,

        PanNo: this.state.PanNo,
        PanNoDoc: this.state.PanNoDoc,
        AadharNo:
          this.state.RoleId === "3"
            ? this.state.DocumentNo
            : this.state.AadharNo,
        GstNo: this.state.GstNo,
        GstCertificate: this.state.GstCertificate,
        AadharImage: this.state.AadharDoc1,
        AadharBackImage: this.state.AadharDoc2,

        CompanyTypeId: this.state.CompanyTypeId,
        PaymentMode: this.state.PaymentMode,

        CreditDays: this.state.CreditDays,
        CreditLimit: this.state.CreditLimit,
        TurnoverPA: this.state.TurnoverPA,
        SecurityChequeNo: this.state.SecurityChequeNo,

        AccountHolderImg: this.state.AccountHolderImg,
        ChequeImage: this.state.ChequeImage,
        ResAddressDoc1: this.state.ResAddressDoc1,
        ResAddressDoc2: this.state.ResAddressDoc2,
        CounterDoc: this.state.CounterDoc,

        DOB: this.state.DOB,

        ResStateId: this.state.ResStateId,
        ResCityId: this.state.ResCityId,
        Respincode: this.state.Respincode,
        ResAddress: this.state.ResAddress,
        ResPhoneNo: this.state.ResPhoneNo,

        AccountNo: this.state.AccountNo,
        IfscCode: this.state.IfscCode,
        BankName: this.state.BankName,
        Branch: this.state.Branch,
        UpiAddress: this.state.UpiAddress,

        RegisterdBySalesId: this.state.RegisterdBySalesId,
        DistributorId: this.state.DistributorId
          ? parseInt(this.state.DistributorId)
          : 0, // ← ADD THIS
      };
      //  debugger;
      if (this.state.RoleId === "9") {
        if (formData.UserId > 0) {
          console.log("Form Data to update:", formData);
          this.props.updateDistributor(formData, this.tblResponse);
        } else {
          console.log("Form Data to create:", formData);
          this.props.createDistributor(formData, this.tblResponse);
        }
      } else if (formData.UserId > 0) {
        this.props.updateDealer(formData, this.tblResponse);
      } else {
        this.props.createDealer(formData, this.tblResponse);
      }

      setTimeout(() => {
        this.props.fetchApi(this.tblResponse);
      }, 1000);
    }
  }
  getRoleDDL(event) {
    this.props.getRoleDDL();
  }

  resetForm() {
    this.setState({
      isEditing: false,
      UserId: 0,
      DealerId: 0,
      PanNo: "",
      AadharNo: "",
      UpiAddress: "",
      WorkshopName: "",
      District: "",
      GstNo: "",
      GstCertificate: "",
      AadharDoc1: "",
      AadharDoc2: "",
      PanNoDoc: "",
      WorkshopImg: "",
      DocumentType: "",
      RegisterdBySalesId: "",
      DocumentNo: "",
      BankName: "",
      Branch: "",
      AccountNo: "",
      IfscCode: "",
      Address: "",
      Pincode: "",
      country: "",
      state: "",
      city: "",
      CreatedDate: "",
      UpdatedDate: "",
      compId: "",
      UserTypeId: "",
      DealerName: "",
      UserName: "",
      CompanyName: "",
      RoleId: "",
      CityId: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      OriginalPassword: "",
      IsActive: true,
      ResStateId: "",
      ResCityId: "",
      Respincode: "",
      ResAddress: "",
      CompanyTypeId: 0,
      CreditLimit: 0,
      DistributorId: "",
      formError: {
        DealerName: "",
        FirmName: "",
        DistFirmName: "",
        UserName: "",
        CompanyName: "",
        UserTypeId: "",
        Email: "",
        MobileNo: "",
        Password: "",
        ConfirmPassword: "",
        PanNo: "",
        AadharNo: "",
        UpiAddress: "",
        WorkshopName: "",
        District: "",
        Address: "",
        Pincode: "",
        country: "",
        state: "",
        city: "",
        GstCertificate: "",
        AadharDoc1: "",
        AadharDoc2: "",
        DocumentType: "",
        RegisterdBySalesId: "",
        DocumentNo: "",
        BankName: "",
        Branch: "",
        AccountNo: "",
        IfscCode: "",
        PanNoDoc: "",
        WorkshopImg: "",
        GstNo: "",
        RoleId: "",
        CityId: "",
        ResStateId: "",
        ResCityId: "",
        Respincode: "",
        ResAddress: "",
        DistributorId: "",
      },
    });

    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
      return errors[key];
    });
  }

  onPage(event) {
    const pageSize = Number(event.rows) || this.state.rows;
    const pageSizeChanged = pageSize !== this.state.rows;
    const first = pageSizeChanged ? 0 : Number(event.first) || 0;
    const pageNo = Math.floor(first / pageSize) + 1;

    this.setState({ rows: pageSize, first });
    Object.assign(this.tblResponse, {
      PageNo: pageNo,
      PageSize: pageSize,
      First: first + 1,
      IsActive: true,
      FromDate: formatApiDateTime(this.state.FromDate),
      ToDate: formatApiDateTime(this.state.ToDate),
    });

    this.props.loadingData(true);
    this.props.fetchApi({ ...this.tblResponse });
  }

  // searchFilter(e) {
  //   const searchValue = e.value || "";
  //   clearTimeout(this.searchTimeout);
  //   this.setState({ selectedUserType: searchValue, searchText: "", first: 0 });
  //   this.props.loadingData(true);
  //   this.tblResponse.SearchValue = searchValue;
  //   this.tblResponse.First = 1;
  //   this.props.fetchApi(this.tblResponse);
  // }

  // searchFilter2(e) {
  //   const searchValue = e.target.value || "";
  //   this.setState({ selectedUserType: "", searchText: searchValue, first: 0 });
  //   this.props.loadingData(true);
  //   clearTimeout(this.searchTimeout);
  //   this.searchTimeout = setTimeout(() => {
  //     this.tblResponse.SearchValue = searchValue;
  //     this.tblResponse.First = 1;
  //     this.props.fetchApi(this.tblResponse);
  //   }, 300);
  // }

  searchFilter = (e) => {
    const searchValue = e.value || "";

    clearTimeout(this.searchTimeout);

    this.setState({
      selectedUserType: searchValue,
      searchText: "",
      first: 0,
    });

    this.tblResponse.SearchValue = searchValue;
    this.tblResponse.First = 1;
    this.tblResponse.PageNo = 1;
    this.tblResponse.PageSize = this.state.rows;

    this.props.loadingData(true);
    this.props.fetchApi({ ...this.tblResponse });
  };
  searchFilter2 = (e) => {
    const searchValue = e.target.value || "";

    clearTimeout(this.searchTimeout);

    this.setState({
      selectedUserType: "",
      searchText: searchValue,
      first: 0,
    });

    this.props.loadingData(true);

    this.searchTimeout = setTimeout(() => {
      this.tblResponse.SearchValue = searchValue;
      this.tblResponse.First = 1;
      this.tblResponse.PageNo = 1;
      this.tblResponse.PageSize = this.state.rows;

      this.props.fetchApi({ ...this.tblResponse });
    }, 300);
  };

  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
  }

  photoBodyTemplate(e) {
    return <img src={e.GstCertificate} width="50px" />;
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }

  openDialog() {
    this.props.onHideShow(true);
    this.setState({ buttonLabel: "Submit", formHeading: "Add User" });
    this.resetForm();
    this.props.getStateDDL(1);
    this.props.getDStateDDL(1);
  }

  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
  }

  actionBodyTemplate(rowData) {
    const editMode = (e) => {
      this.resetFormError();
      this.props.onHideShow(true);
      this.props.getStateDDL(1);
      this.props.getDStateDDL(1);
      this.props.getRoleDDL(2);
      this.getCityList(rowData.State, "B", "");
      this.getDCityList(rowData.State, "CI", "");

      this.setState({
        isImage: true,
        UserId: rowData.UserId,
        isEditing: true,
        buttonLabel: "Update",
        formHeading: "Update User",
        IsActive: rowData.IsActive,
        RoleId: rowData.RoleId.toString(),
        Email: rowData.Email,
        MobileNo: rowData.MobileNo,
        Password: rowData.Password || "",
        ConfirmPassword: rowData.Password || "",
        OriginalPassword: rowData.Password || "",
        CreatedDate: rowData.CreatedDate,
        DealerId: rowData.DealerId,
        UserName: rowData.UserName,
        AadharNo: rowData.AadharNo || rowData.DocumentNo || "",
        DocumentNo: rowData.AadharNo || rowData.DocumentNo || "",
        DocumentType: rowData.DocumentType,
        AadharDoc1: rowData.AadharImage || rowData.AadharDoc1 || "",
        AadharDoc2: rowData.AadharBackImage || rowData.AadharDoc2 || "",
        GstNo: rowData.GstNo,
        GstCertificate: rowData.GstCertificate,
        AccountHolderImg: rowData.AccountHolderImg,
        ChequeImage: rowData.ChequeImage,
        ResAddressDoc1: rowData.ResAddressDoc1,
        ResAddressDoc2: rowData.ResAddressDoc2,
        CounterDoc: rowData.CounterDoc,
        UpiAddress: rowData.UpiAddress,
        IfscCode: rowData.IfscCode,
        BankName: rowData.BankName,
        Branch: rowData.Branch,
        AccountNo: rowData.AccountNo,
        PanNo: rowData.PanNo,
        PanNoDoc: rowData.PanNoDoc,

        Address: rowData.Address,
        Pincode: rowData.Pincode,
        country: 1,
        state: rowData.State,
        city: rowData.City,
        NameOfBussiness: rowData.NameOfBussiness,
        LandlineNo: rowData.LandlineNo,
        CreditDays: rowData.CreditDays,
        PaymentMode: rowData.PaymentMode,
        CompanyTypeId: rowData.CompanyTypeId.toString(),
        DOB: rowData.DOB,
        CreditLimit: rowData.CreaditLimit,
        TurnoverPA: rowData.TurnoverPA,
        SecurityChequeNo: rowData.SecurityChequeNo,
        SalsePersone: rowData.SalsePersone,
        ResAddress: rowData.ResAddress,
        Respincode: rowData.Respincode,
        ResPhoneNo: rowData.ResPhoneNo,
        RegisterdBySalesId: rowData.RegisterdBySalesId,
        ResCityId: rowData.ResCityId.toString(),
        ResStateId: rowData.ResStateId.toString(),
        // ── FIXED: these two were missing ──  //sam
        AddressFirm: rowData.AddressFirm || rowData.Address || "",
        pincode: rowData.pincode || rowData.Pincode || "",
        // ── NEW: distributor link for dealer ──

        DistributorId: rowData.DistributorId
          ? rowData.DistributorId.toString()
          : "",

        AddressFirm: rowData.AddressFirm || rowData.Address || "",

        pincode: rowData.pincode || rowData.Pincode || "",

        state: rowData.State ? rowData.State.toString() : "",

        city: rowData.City ? rowData.City.toString() : "",

        CompanyTypeId: rowData.CompanyTypeId
          ? rowData.CompanyTypeId.toString()
          : "",

        ResStateId: rowData.ResStateId ? rowData.ResStateId.toString() : "",

        ResCityId: rowData.ResCityId ? rowData.ResCityId.toString() : "",

        RegisterdBySalesId: rowData.RegisterdBySalesId
          ? rowData.RegisterdBySalesId.toString()
          : "",

        DistributorId: rowData.DistributorId
          ? rowData.DistributorId.toString()
          : "",
      });
    };
    const switchHandleChange = (e) => {
      this.setState({
        switchAction: !rowData.IsActive,
        UserId: rowData.UserId,
      });
      this.props.onHideShowIsActive(true);
    };

    if (rowData) {
      return (
        <>
          {this.state.IsEdit === true ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "nowrap",
              }}
            >
              <Switch
                checked={rowData.IsActive}
                color="primary"
                name={rowData.UserId}
                onChange={switchHandleChange}
                inputProps={{ "aria-label": "secondary checkbox" }}
                style={{ flexShrink: 0 }}
              />
              <Button
                icon="pi pi-pencil"
                onClick={editMode}
                className="p-button-sm p-button-text"
                style={{ flexShrink: 0 }}
              />
              {(rowData.RoleName === "Dealer" ||
                rowData.RoleName === "HHT-Distributor" ||
                rowData.RoleName === "Sub_Dealer") && (
                <>
                  <Button
                    icon="pi pi-download"
                    className="p-button-sm p-button-success"
                    onClick={() => downloadUserRegForm(rowData.UserRegFormPath)}
                    tooltipOptions={{ position: "top" }}
                    style={{ flexShrink: 0 }}
                  />
                  {rowData.RoleName === "Dealer" && (
                    <input
                      type="checkbox"
                      checked={rowData.isPayment || false}
                      onChange={(e) =>
                        this.handleCheckboxChange(rowData, e.target.checked)
                      }
                      style={{ flexShrink: 0 }}
                    />
                  )}
                </>
              )}
            </div>
          ) : (
            ""
          )}
        </>
      );
    }
  }

  // Format data for CSV export
  formatExportData = (data) => {
    console.log("Export Data Sample:", data[0]); // Debug log to check data structure
    return data.map((item) => ({
      UserName:
        item.UserName || item.username || item.userName || item.Username || "", // Try both variations
      RoleName: item.RoleName || item.roleName || "",
      Email: item.Email || item.email || "",
      MobileNo: item.MobileNo || item.mobileNo || "",
      StateName: item.StateName || item.stateName || "",
      CityName: item.CityName || item.cityName || "",
      Pincode: item.Pincode || item.pincode || "",
      PanNo: item.PanNo || item.panNo || "",
      GstNo: item.GstNo || item.gstNo || "",
      AadharNo: item.AadharNo || item.aadharNo || "",
      DocumentNo: item.DocumentNo || item.documentNo || "",
      IsActive: item.IsActive ? "Inactive" : "Active",
      CreatedDate: item.CreatedDate
        ? new Date(item.CreatedDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "",
    }));
  };

  // Fixed exportCSV function
  exportCSV = async () => {
    try {
      this.tblResponse.FromDate = formatApiDateTime(this.state.FromDate);
      this.tblResponse.ToDate = formatApiDateTime(this.state.ToDate);
      this.tblResponse.First = -1;
      this.tblResponse.PageSize = -1;

      //toast.info("Preparing export...");

      await this.props.exportData(this.tblResponse);

      // Wait for data to load then trigger download
      setTimeout(() => {
        if (
          this.csvLink.current &&
          this.props.List &&
          this.props.List.length > 0
        ) {
          this.csvLink.current.link.click();
          // toast.success("Export completed successfully");
        } else {
          toast.error("No data available to export");
        }
      }, 1000);
    } catch (error) {
      toast.error("Export failed: " + error.message);
    }
  };

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  render() {
    const renderFooter = (name) => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={this.switchToggleConfirm}
            autoFocus
          />
        </div>
      );
    };

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />
        <div>
          {" "}
          <h4>Mobile User Master</h4>
        </div>
        <div className="table-header row mb-3">
          <div className="col-md-2 master_headhingcol">
            <span>
              <Dropdown
                appendTo={document.getElementById("root")}
                value={this.state.selectedUserType}
                options={this.state.userFilterData}
                optionValue="value"
                optionLabel="label"
                className="form-control custom-select"
                placeholder={"Select User Type"}
                name="selectedUserType"
                filter
                onChange={this.searchFilter}
              />
            </span>
          </div>

          <div className="col-md-2 text-right">
            <div>
              <Calendar
                placeholder="From Date"
                name="FromDate"
                showIcon="true"
                value={this.state.FromDate}
                onChange={this.handleChange}
              ></Calendar>
            </div>
          </div>
          <div className="col-md-2 text-center">
            <div>
              <Calendar
                placeholder="To Date"
                name="ToDate"
                showIcon="true"
                value={this.state.ToDate}
                onChange={this.handleChange}
                minDate={this.state.FromDate}
              ></Calendar>
            </div>
          </div>
          <div
            className="col-md-5 text-right"
            style={{ marginLeft: "-1px", marginTop: "-6px" }}
          >
            <div className="d-inline-flex align-items-center">
              <button
                onClick={this.exportCSV}
                className="btn btn-success p-2 pl-3 pr-4 ml-3"
              >
                Export
              </button>
              <span
                className="p-input-icon-left"
                style={{ marginLeft: "-1px", marginTop: "-1px" }}
              >
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  value={this.state.searchText}
                  onChange={this.searchFilter2}
                  placeholder="Global Search"
                  style={{ width: "160px" }}
                />
              </span>
              {this.state.IsAdd === true ? (
                <Button
                  className="ml-3"
                  label="Add User"
                  icon="pi pi-plus-circle"
                  onClick={this.openDialog}
                  style={{ width: "90px", height: "40px" }}
                />
              ) : (
                <Button
                  className="ml-2"
                  label="Add User"
                  icon="pi pi-plus-circle"
                  onClick={this.openDialog}
                  style={{ width: "90px", height: "40px" }}
                />
              )}
            </div>

            {/* Fixed CSVLink */}
            <CSVLink
              data={this.formatExportData(this.props.UserData || [])}
              headers={this.state.headers}
              filename={"Mobile_User_Report.csv"}
              className="hidden"
              ref={this.csvLink}
            ></CSVLink>
          </div>
        </div>

        <div className="card">
          <DataTable
            value={this.props.UserData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%", tableLayout: "fixed" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="UserName"
              header="Name"
              sortable
              style={{ width: "150px", minWidth: "120px" }}
            ></Column>
            <Column
              field="RoleName"
              header="User Type"
              sortable
              style={{ width: "120px", minWidth: "100px" }}
            ></Column>

            <Column
              field="Email"
              header="Email"
              sortable
              style={{
                width: "300px",
                minWidth: "180px",
                wordBreak: "break-word",
              }}
            ></Column>
            <Column
              field="MobileNo"
              header="Mobile Number"
              sortable
              style={{ width: "150px", minWidth: "120px" }}
            ></Column>
            <Column
              field="StateName"
              header="State"
              sortable
              style={{ width: "100px", minWidth: "80px" }}
            ></Column>

            <Column
              field="CityName"
              header="City"
              sortable
              style={{ width: "100px", minWidth: "80px" }}
            ></Column>
            <Column
              field="Pincode"
              header="Pincode"
              sortable
              style={{ width: "100px", minWidth: "80px" }}
            ></Column>
            <Column
              field="CreatedDate"
              header="Created Date"
              sortable
              style={{ width: "100px", minWidth: "80px" }}
              body={(rowData) =>
                rowData.CreatedDate
                  ? new Date(rowData.CreatedDate).toLocaleDateString("en-GB")
                  : ""
              }
            />
            {this.state.IsEdit === true ? (
              <Column
                field="Action"
                header="Action"
                className="rolemaster-button1"
                style={{ minWidth: "250px", maxWidth: "250px" }}
                body={this.actionBodyTemplate}
              ></Column>
            ) : (
              <Column
                field="Action"
                header="Action"
                style={{ width: "400px" }}
                style2={{ display: "none" }}
              ></Column>
            )}
          </DataTable>
        </div>

        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          <form autoComplete="off" onSubmit={this.submitForm}>
            <div className="row">
              <div className="col-md-6 pt-3">
                <FormControl
                  variant="outlined"
                  size="small"
                  className="formControl col-md-12"
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Select Type*
                  </InputLabel>
                  {/* <Select
                    disabled={this.state.isEditing}
                    onChange={(event) => {
                      this.handleChange(event);
                    }}
                    name="RoleId"
                    value={this.state.RoleId}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Select Type*"
                  >
                    <MenuItem>
                      <em>Select Type</em>
                      <span>*</span>
                    </MenuItem>
                    {this.props.UserRoleData &&
                      this.props.UserRoleData.map((key) => (
                        <MenuItem value={key.value}>{key.label}</MenuItem>
                      ))}
                  </Select> */}
                  <Select
                    name="RoleId"
                    value={this.state.RoleId}
                    onChange={(e) => {
                      this.handleChange(e);

                      this.setState({
                        showDistributorSection: e.target.value === "9",
                      });

                      if (e.target.value === "9") {
                        this.props.getStateDDL(1);
                        this.props.getDStateDDL(1);
                      }
                    }}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Select Type*"
                    disabled={this.state.isEditing}
                  >
                    <MenuItem value="">Select Type</MenuItem>
                    {this.props.UserRoleData &&
                      this.props.UserRoleData.filter(
                        (key) => key.label !== "Mobile-User",
                      ).map((key) => (
                        <MenuItem key={key.value} value={key.value}>
                          {key.label}
                        </MenuItem>
                      ))}
                  </Select>

                  {this.state.formError.RoleId !== "" ? (
                    <div className="error">{this.state.formError.RoleId}</div>
                  ) : (
                    ""
                  )}
                </FormControl>
              </div>

              <div className="col-md-6 pt-3">
                <TextField
                  onChange={this.handleChange}
                  disabled={this.state.isEditing}
                  name="UserName"
                  autoComplete="false"
                  value={this.state.UserName}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="User Name*"
                />
                {this.state.formError.UserName !== "" ? (
                  <div className="error">{this.state.formError.UserName}</div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 pt-3">
                <TextField
                  onChange={this.handleChange}
                  disabled={this.state.isEditing}
                  name="Email"
                  value={this.state.Email}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Email*"
                />
                {this.state.formError.Email !== "" ? (
                  <div className="error">{this.state.formError.Email}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 pt-3">
                <TextField
                  disabled={this.state.isEditing}
                  id="standard-basic"
                  size="small"
                  onChange={this.handleChange}
                  variant="outlined"
                  name="MobileNo"
                  value={this.state.MobileNo}
                  className="fullwidth"
                  label="Mobile Number*"
                  type="number"
                  inputProps={{ maxLength: 10 }}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                />
                {this.state.formError.MobileNo !== "" ? (
                  <div className="error">{this.state.formError.MobileNo}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 pt-3">
                <TextField
                  input
                  type="password"
                  autoComplete="new-password"
                  onChange={this.handleChange}
                  name="Password"
                  value={this.state.Password}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Password*"
                />
                {this.state.formError.Password !== "" ? (
                  <div className="error">{this.state.formError.Password}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 pt-3">
                <TextField
                  input
                  type="password"
                  onChange={this.handleChange}
                  name="ConfirmPassword"
                  value={this.state.ConfirmPassword}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Confirm Password*"
                />
                {this.state.formError.ConfirmPassword !== "" ? (
                  <div className="error">
                    {this.state.formError.ConfirmPassword}
                  </div>
                ) : (
                  ""
                )}
              </div>
              {this.state.RoleId === "2" ||
              this.state.RoleId === "3" ||
              this.state.RoleId === "5" ||
              this.state.RoleId === "10" ? (
                <>
                  <div className="col-md-6 pt-3">
                    <TextField
                      id="standard-basic"
                      size="small"
                      variant="outlined"
                      name="PanNo"
                      onChange={this.handleChange}
                      value={this.state.PanNo}
                      className="fullwidth"
                      //label="Pan Card Number*"
                      label={
                        <>
                          Pan Card Number
                          {(this.state.RoleId == 3 ||
                            this.state.RoleId == 5) && (
                            <span style={{ color: "black" }}>*</span>
                          )}{" "}
                        </>
                      }
                    />
                    {this.state.formError.PanNo !== "" ? (
                      <div className="error">{this.state.formError.PanNo}</div>
                    ) : (
                      ""
                    )}
                  </div>
                  {this.state.RoleId === "5" ||
                    (this.state.RoleId === "10" && (
                      <div className="col-md-6 pt-3">
                        <FormControl
                          variant="outlined"
                          size="small"
                          className="formControl col-md-12 custom-select"
                        >
                          <Dropdown
                            appendTo={document.getElementById("root")}
                            value={this.state.DistributorId}
                            options={this.props.DistributorDDL || []}
                            optionValue="value"
                            optionLabel="label"
                            className="form-control custom-select"
                            placeholder="Select Distributor"
                            name="DistributorId"
                            onChange={this.handleChange}
                            filter={true}
                          />
                        </FormControl>
                        {this.state.formError.DistributorId !== "" && (
                          <div className="error">
                            {this.state.formError.DistributorId}
                          </div>
                        )}
                      </div>
                    ))}

                  {(this.state.RoleId === "2" ||
                    this.state.RoleId === "5" ||
                    this.state.RoleId === "10") && (
                    <div className="col-md-6 pt-3">
                      <FormControl
                        variant="outlined"
                        size="small"
                        className="formControl col-md-12 custom-select"
                      >
                        <Dropdown
                          appendTo={document.getElementById("root")}
                          value={this.state.RegisterdBySalesId}
                          options={this.props.SalesPersonIdList || []}
                          optionValue="Value"
                          optionLabel="Label"
                          className="form-control custom-select"
                          placeholder={"Registerd By Sales Person *"}
                          name="RegisterdBySalesId"
                          onChange={this.handleChange}
                          filter
                        />
                      </FormControl>

                      {this.state.formError.RegisterdBySalesId !== "" && (
                        <div className="error">
                          {this.state.formError.RegisterdBySalesId}
                        </div>
                      )}
                    </div>
                  )}

                  {this.state.RoleId === "2" ||
                    (this.state.RoleId === "10" && (
                      <div className="col-md-6 pt-3">
                        <FormControl
                          variant="outlined"
                          size="small"
                          className="formControl col-md-12 custom-select"
                        >
                          <Dropdown
                            appendTo={document.getElementById("root")}
                            value={this.state.DocumentType}
                            options={this.props.DocumentTypes || []}
                            optionValue="Value"
                            optionLabel="Label"
                            className="form-control custom-select"
                            placeholder={"Select Document Type *"}
                            name="DocumentType"
                            onChange={this.handleChange}
                            filter
                          />
                        </FormControl>

                        {this.state.formError.DocumentType !== "" && (
                          <div className="error">
                            {this.state.formError.DocumentType}
                          </div>
                        )}
                      </div>
                    ))}
                  <div className="col-md-6 pt-3">
                    {(this.state.RoleId === "3" ||
                      this.state.RoleId === "2" ||
                      this.state.RoleId === "10") && (
                      <>
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="DocumentNo"
                          onChange={this.handleChange}
                          value={this.state.DocumentNo}
                          className="fullwidth"
                          label={
                            this.state.RoleId === "3"
                              ? "Aadhar Number*"
                              : "Document Number*"
                          }
                          type="text"
                        />
                        {this.state.formError.DocumentNo && (
                          <div className="error">
                            {this.state.formError.DocumentNo}
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {(this.state.RoleId === "2" ||
                    this.state.RoleId === "5" ||
                    this.state.RoleId === "10") && (
                    <>
                      <div className="col-md-6 pt-3">
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="UpiAddress"
                          onChange={this.handleChange}
                          value={this.state.UpiAddress}
                          className="fullwidth"
                          label="UPI ID"
                        />
                        {this.state.formError.UpiAddress !== "" && (
                          <div className="error">
                            {this.state.formError.UpiAddress}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3">
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="BankName"
                          onChange={this.handleChange}
                          value={this.state.BankName}
                          className="fullwidth"
                          label="Bank Name *"
                        />
                        {this.state.formError.BankName !== "" && (
                          <div className="error">
                            {this.state.formError.BankName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3">
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="IfscCode"
                          onChange={this.handleChange}
                          value={this.state.IfscCode}
                          className="fullwidth"
                          label="IFSC Code*"
                        />
                        {this.state.formError.IfscCode !== "" && (
                          <div className="error">
                            {this.state.formError.IfscCode}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3">
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="Branch"
                          onChange={this.handleChange}
                          value={this.state.Branch}
                          className="fullwidth"
                          label="Branch Name *"
                        />
                        {this.state.formError.Branch !== "" && (
                          <div className="error">
                            {this.state.formError.Branch}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3">
                        <TextField
                          id="standard-basic"
                          size="small"
                          variant="outlined"
                          name="AccountNo"
                          onChange={this.handleChange}
                          value={this.state.AccountNo}
                          className="fullwidth"
                          label="Account Number *"
                        />
                        {this.state.formError.AccountNo !== "" && (
                          <div className="error">
                            {this.state.formError.AccountNo}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <div
                    hidden={this.state.RoleId !== "5"}
                    className="col-md-6 pt-3"
                  >
                    <TextField
                      id="standard-basic"
                      size="small"
                      variant="outlined"
                      name="GstNo"
                      onChange={this.handleChange}
                      value={this.state.GstNo}
                      className="fullwidth"
                      label="GSTIN*"
                    />
                    {this.state.formError.GstNo !== "" ? (
                      <div className="error">{this.state.formError.GstNo}</div>
                    ) : null}
                  </div>

                  <div
                    hidden={this.state.RoleId !== "5"}
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Upload GST certificate<span>*</span>:
                    </label>
                    <FileUpload
                      name="GstCertificate"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePath}
                      onError={this.onErrorImage}
                      accept="application/pdf,image/*"
                    />

                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}

                    <div className="col-md-12 mb-3">
                      {this.state.GstCertificate && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div className="mt-2">
                            <a
                              href={this.state.GstCertificate}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={this.handleOpenModal}
                            >
                              📄 View GSTIN Certificate (PDF)
                            </a>

                            {this.state.showModal && (
                              <div
                                className="modal fade show d-block"
                                tabIndex="-1"
                              >
                                <div className="modal-dialog modal-xl custom-modal-width">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        GSTIN Certificate
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.handleCloseModal}
                                      >
                                        Close
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <iframe
                                        src={this.state.GstCertificate}
                                        width="100%"
                                        height="470px"
                                        style={{ border: "none" }}
                                        title="GST Certificate"
                                      ></iframe>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {this.state.showModal && (
                              <div
                                className="modal-backdrop fade show"
                                onClick={this.handleCloseModal}
                              ></div>
                            )}
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.GstCertificate ? (
                        <div className="error">
                          {this.state.formError.GstCertificate}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div
                    hidden={
                      this.state.RoleId === "5" || this.state.RoleId === "10"
                        ? false
                        : true
                    }
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Account Holder Image<span>*</span>:
                    </label>
                    <FileUpload
                      name="AccountHolderImg"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePathAccountHolder}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.AccountHolderImg && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={this.state.AccountHolderImg}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.AccountHolderImg}
                                width="100px"
                                height="100"
                                style={{ cursor: "pointer" }}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.AccountHolderImg !== null ? (
                        <div className="error">
                          {this.state.formError.AccountHolderImg}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div
                    hidden={
                      this.state.RoleId === "5" || this.state.RoleId === "10"
                        ? false
                        : true
                    }
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Cheque Image<span>*</span>:
                    </label>
                    <FileUpload
                      name="ChequeImage"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePathAccountHolder2}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.ChequeImage && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={this.state.ChequeImage}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.ChequeImage}
                                width="100px"
                                height="100"
                                style={{ cursor: "pointer" }}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.ChequeImage !== null ? (
                        <div className="error">
                          {this.state.formError.ChequeImage}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div
                    hidden={
                      this.state.RoleId === "5" || this.state.RoleId === "10"
                        ? false
                        : true
                    }
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Res Address Front<span>*</span>:
                    </label>
                    <FileUpload
                      name="ResAddressDoc1"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePathAccountHolder3}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.ResAddressDoc1 && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={this.state.ResAddressDoc1}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.ResAddressDoc1}
                                width="100px"
                                height="100"
                                style={{ cursor: "pointer" }}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.ResAddressDoc1 !== null ? (
                        <div className="error">
                          {this.state.formError.ResAddressDoc1}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div
                    hidden={
                      this.state.RoleId === "5" || this.state.RoleId === "10"
                        ? false
                        : true
                    }
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Res Address Back<span>*</span>:
                    </label>
                    <FileUpload
                      name="ResAddressDoc2"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePathAccountHolder4}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.ResAddressDoc2 && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={this.state.ResAddressDoc2}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.ResAddressDoc2}
                                width="100px"
                                height="100"
                                style={{ cursor: "pointer" }}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.ResAddressDoc2 !== null ? (
                        <div className="error">
                          {this.state.formError.ResAddressDoc2}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div
                    hidden={
                      this.state.RoleId === "5" || this.state.RoleId === "10"
                        ? false
                        : true
                    }
                    className="col-md-6 pt-3"
                  >
                    <label>
                      Upload Counter Image<span>*</span>:
                    </label>
                    <FileUpload
                      name="CounterDoc"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePathAccountHolder5}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf !== "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.CounterDoc && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={this.state.CounterDoc}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.CounterDoc}
                                width="100px"
                                height="100"
                                style={{ cursor: "pointer" }}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.CounterDoc !== null ? (
                        <div className="error">
                          {this.state.formError.CounterDoc}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {this.state.RoleId !== "5" && this.state.RoleId !== "10" && (
                    <div className="col-md-6 pt-3">
                      {(this.state.RoleId === "3" ||
                        this.state.RoleId === "2") && (
                        <>
                          <label>
                            Upload{" "}
                            {this.state.RoleId === "3"
                              ? "Aadhar Front Image "
                              : "Document Front Image "}
                            <span>*</span>:
                          </label>

                          <FileUpload
                            name="AadharDoc1"
                            mode="basic"
                            url={
                              process.env.REACT_APP_API_URL +
                              "UploadFile/ImageUpload"
                            }
                            auto={true}
                            onUpload={this.setImage}
                            onError={this.onErrorImage}
                            accept="image/*"
                          />
                          {this.state.pdf !== "" ? (
                            <b>{this.state.pdf}</b>
                          ) : null}

                          <div className="col-md-12 mb-3">
                            {this.state.AadharDoc1 && this.state.isImage ? (
                              <div
                                className="p-fileupload-content mt-3 p-1"
                                style={{
                                  display: "table",
                                  border: "1px solid #ccc",
                                }}
                              >
                                <div>
                                  <a
                                    href={
                                      this.state.AadharDoc1 === ""
                                        ? true
                                        : this.state.AadharDoc1
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      alt="img doc"
                                      role="presentation"
                                      src={this.state.AadharDoc1}
                                      width="100px"
                                      height={100}
                                    />
                                  </a>
                                </div>
                              </div>
                            ) : null}

                            {this.state.formError.AadharDoc1 && (
                              <div className="error">
                                {this.state.formError.AadharDoc1}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  {this.state.RoleId !== "5" && this.state.RoleId !== "10" && (
                    <div className="col-md-6 pt-3">
                      {(this.state.RoleId === "3" ||
                        this.state.RoleId === "2") && (
                        <>
                          <label>
                            Upload{" "}
                            {this.state.RoleId === "3"
                              ? "Aadhar Back Image"
                              : "Document Back Image"}
                            <span>*</span>:
                          </label>

                          <FileUpload
                            name="AadharDoc2"
                            mode="basic"
                            url={
                              process.env.REACT_APP_API_URL +
                              "UploadFile/ImageUpload"
                            }
                            auto={true}
                            onUpload={this.setImageAadharDoc2}
                            onError={this.onErrorImage}
                            accept="image/*"
                          />
                          {this.state.pdf !== "" ? (
                            <b>{this.state.pdf}</b>
                          ) : null}

                          <div className="col-md-12 mb-3">
                            {this.state.AadharDoc2 && this.state.isImage ? (
                              <div
                                className="p-fileupload-content mt-3 p-1"
                                style={{
                                  display: "table",
                                  border: "1px solid #ccc",
                                }}
                              >
                                <div>
                                  <a
                                    href={
                                      this.state.AadharDoc2 === ""
                                        ? true
                                        : this.state.AadharDoc2
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      alt="img doc"
                                      role="presentation"
                                      src={this.state.AadharDoc2}
                                      width="100px"
                                      height={100}
                                    />
                                  </a>
                                </div>
                              </div>
                            ) : null}

                            {this.state.formError.AadharDoc2 && (
                              <div className="error">
                                {this.state.formError.AadharDoc2}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  <div className="col-md-6 pt-3">
                    <label>
                      Upload PAN Number
                      {this.state.RoleId == 3 ||
                      this.state.RoleId == 5 ||
                      this.state.RoleId == 10 ? (
                        <span>*</span>
                      ) : (
                        ""
                      )}
                      :
                    </label>
                    <FileUpload
                      name="PanNoDoc"
                      mode="basic"
                      url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                      }
                      auto={true}
                      onUpload={this.setImagePath2}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    {this.state.pdf != "" ? <b>{this.state.pdf}</b> : null}
                    <div className="col-md-12 mb-3">
                      {this.state.PanNoDoc && this.state.isImage ? (
                        <div
                          className="p-fileupload-content mt-3 p-1"
                          style={{ display: "table", border: "1px solid #ccc" }}
                        >
                          <div>
                            <a
                              href={
                                this.state.PanNoDoc == ""
                                  ? true
                                  : this.state.PanNoDoc
                              }
                              target="_blank"
                            >
                              <img
                                alt="img doc"
                                role="presentation"
                                src={this.state.PanNoDoc}
                                width="100"
                                height={100}
                              />
                            </a>
                          </div>
                        </div>
                      ) : null}

                      {this.state.formError.PanNoDoc !== null ? (
                        <div className="error">
                          {this.state.formError.PanNoDoc}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* <div className="col-md-6 pt-3">
                       <label>
                        Upload  Counter Image:
                        </label>
                        <FileUpload
                        name="CounterDoc"
                        mode="basic"
                        url={
                        process.env.REACT_APP_API_URL + "UploadFile/ImageUpload"
                        }
                        auto={true}
                        onUpload={this.setImage1}
                        onError={this.onErrorImage}
                        accept="image/*"
                         />
                        {this.state.pdf != "" ? <b>{this.state.pdf}</b> : null}
                        <div className="col-md-12 mb-3">
                        {this.state.CounterDoc && this.state.isImage ? (
                        <div
                        className="p-fileupload-content mt-3 p-1"
                        style={{ display: "table", border: "1px solid #ccc" }}
                        >
                        <div>
                        <a
                         href={
                                                   this.state.CounterDoc == ""
                                                     ? true
                                                     : this.state.CounterDoc
                                                 }
                                                 target="_blank"
                                               >
                                                 <img
                                                   alt="img doc"
                                                   role="presentation"
                                                   src={this.state.CounterDoc}
                                                   width="100"
                                                   height={100}
                                                 />
                                               </a>
                                             </div>
                                           </div>
                                         ) : null}
                   
                                         {this.state.formError.CounterDoc !== null ? (
                                           <div className="error">
                                             {this.state.formError.CounterDoc}
                                           </div>
                                         ) : null}
                                       </div>
                                     </div> */}
                  <div hidden className="col-md-6 pt-3">
                    <Checkbox
                      name="IsActive"
                      checked={this.state.IsActive}
                      onClick={this.handleChange}
                      color="primary"
                      inputProps={{ "aria-label": "secondary checkbox" }}
                    />{" "}
                    <label>Is Active</label>
                  </div>

                  <div className="col-md-12 bordercolor">
                    <fieldset>
                      <div className="row">
                        <legend className="col-md-12 billing-add">
                          Address*
                        </legend>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12"
                              >
                                <InputLabel id="demo-simple-select-outlined-label">
                                  Select Country*
                                </InputLabel>
                                <Select
                                  onChange={(e) => {
                                    this.getStateList(e, "B");
                                  }}
                                  name="country"
                                  value={this.state.country}
                                  labelId="demo-simple-select-outlined-label"
                                  id="demo-simple-select-outlined"
                                  label="Select Country"
                                >
                                  <MenuItem>
                                    <em>Select Country</em>
                                    <span>*</span>
                                  </MenuItem>
                                  {this.state.CountryData.map((key) => (
                                    <MenuItem value={key.value}>
                                      {key.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              {this.state.formError.country !== "" ? (
                                <div className="error">
                                  {this.state.formError.country}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                {" "}
                                <span></span>
                              </label>
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.city}
                                  onChange={(e) => {
                                    this.handleChange(e);
                                  }}
                                  options={this.props.UserBCityData}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder={
                                    this.state.RoleId != "3"
                                      ? "Select City*"
                                      : this.state.RoleId === "3"
                                        ? "Select Zone*"
                                        : ""
                                  }
                                  name="city"
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.city !== "" ? (
                                <div className="error">
                                  {this.state.formError.city}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="Pincode"
                                value={this.state.Pincode}
                                type="number"
                                inputProps={{ maxLength: 6 }}
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Pincode*"
                                onInput={(e) =>
                                  (e.target.value = e.target.value.slice(0, 6))
                                }
                              />
                              {this.state.formError.Pincode !== null ? (
                                <div className="error">
                                  {this.state.formError.Pincode}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.state}
                                  options={this.props.StateData}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder={"Select State*"}
                                  name="state"
                                  onChange={(e) => {
                                    this.getCityList(e, "B", "i");
                                  }}
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.state !== "" ? (
                                <div className="error">
                                  {this.state.formError.state}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="Address"
                                value={this.state.Address}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Address*"
                              />
                              {this.state.formError.Address !== "" ? (
                                <div className="error">
                                  {this.state.formError.Address}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </>
              ) : (
                ""
              )}

              {this.state.RoleId === "5" ? (
                <>
                  <div className="col-md-12 bordercolor">
                    <fieldset>
                      <div className="row">
                        <legend className="col-md-12 billing-add">
                          Res _ Address*
                        </legend>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12"
                              >
                                <InputLabel id="demo-simple-select-outlined-label">
                                  Select Country*
                                </InputLabel>
                                <Select
                                  onChange={(e) => {
                                    this.getDStateList(e);
                                  }}
                                  name="country"
                                  value={this.state.country}
                                  labelId="demo-simple-select-outlined-label"
                                  id="demo-simple-select-outlined"
                                  label="Select Country"
                                >
                                  <MenuItem>
                                    <em>Select Country</em>
                                    <span>*</span>
                                  </MenuItem>
                                  {this.state.CountryData.map((key) => (
                                    <MenuItem value={key.value}>
                                      {key.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              {this.state.formError.country !== "" ? (
                                <div className="error">
                                  {this.state.formError.country}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                {" "}
                                <span></span>
                              </label>
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.ResCityId}
                                  onChange={(e) => {
                                    this.dhandleChange(e, "D");
                                  }}
                                  options={this.props.UserRCityData}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder="Select City *"
                                  name="ResCityId"
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.ResCityId !== "" ? (
                                <div className="error">
                                  {this.state.formError.ResCityId}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="Respincode"
                                value={this.state.Respincode}
                                type="number"
                                inputProps={{ maxLength: 6 }}
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Pincode*"
                                onInput={(e) =>
                                  (e.target.value = e.target.value.slice(0, 6))
                                }
                              />
                              {this.state.formError.Respincode !== null ? (
                                <div className="error">
                                  {this.state.formError.Respincode}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.ResStateId}
                                  options={this.props.ResStateData}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder={"Select Res State*"}
                                  name="ResStateId"
                                  onChange={(e) => {
                                    this.getDCityList(e, "CI", "Z");
                                  }}
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.ResStateId !== "" ? (
                                <div className="error">
                                  {this.state.formError.ResStateId}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="ResAddress"
                                value={this.state.ResAddress}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Address*"
                              />
                              {this.state.formError.ResAddress !== null ? (
                                <div className="error">
                                  {this.state.formError.ResAddress}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </>
              ) : (
                ""
              )}

              {this.state.RoleId === "5" || this.state.RoleId === "10" ? (
                <>
                  <div className="col-md-12 bordercolor">
                    <fieldset>
                      <div className="row">
                        <legend className="col-md-12 billing-add">
                          Dealer Bussniess informationn *
                        </legend>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="NameOfBussiness"
                                value={this.state.NameOfBussiness}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Name Of Bussiness *"
                              />
                              {this.state.formError.NameOfBussiness !== null ? (
                                <div className="error">
                                  {this.state.formError.NameOfBussiness}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="LandlineNo"
                                value={this.state.LandlineNo}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="LandlineNo"
                              />
                              {this.state.formError.LandlineNo !== null ? (
                                <div className="error">
                                  {this.state.formError.LandlineNo}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="CreditDays"
                                value={this.state.CreditDays}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="CreditDays *"
                              />
                              {this.state.formError.CreditDays !== null ? (
                                <div className="error">
                                  {this.state.formError.CreditDays}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.PaymentMode}
                                  options={this.props.UserPayMentData || []}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder={"Select Payment Mode*"}
                                  name="PaymentMode"
                                  onChange={this.handleChange}
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.PaymentMode !== "" ? (
                                <div className="error">
                                  {this.state.formError.PaymentMode}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <FormControl
                                variant="outlined"
                                size="small"
                                className="formControl col-md-12 custom-select"
                              >
                                <Dropdown
                                  appendTo={document.getElementById("root")}
                                  value={this.state.CompanyTypeId}
                                  options={this.props.UserFirmData || []}
                                  optionValue="value"
                                  optionLabel="label"
                                  className="form-control custom-select"
                                  placeholder={"Select CompanyType*"}
                                  name="CompanyTypeId"
                                  onChange={this.handleChange}
                                  filter
                                />
                              </FormControl>

                              {this.state.formError.CompanyTypeId !== "" ? (
                                <div className="error">
                                  {this.state.formError.CompanyTypeId}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="DOB"
                                value={this.state.DOB}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Date Of Birth *"
                              />
                              {this.state.formError.DOB !== null ? (
                                <div className="error">
                                  {this.state.formError.DOB}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="CreditLimit"
                                value={this.state.CreditLimit}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Credit Limit*"
                              />
                              {this.state.formError.CreditLimit !== null ? (
                                <div className="error">
                                  {this.state.formError.CreditLimit}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="TurnoverPA"
                                value={this.state.TurnoverPA}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="TurnoverPA *"
                              />
                              {this.state.formError.TurnoverPA !== null ? (
                                <div className="error">
                                  {this.state.formError.TurnoverPA}
                                </div>
                              ) : null}
                            </div>

                            <div className="col-md-12">
                              <label>
                                <span></span>
                              </label>
                              <TextField
                                id="standard-basic"
                                name="SecurityChequeNo"
                                value={this.state.SecurityChequeNo}
                                type="text"
                                variant="outlined"
                                size="small"
                                className="fullwidth"
                                onChange={this.handleChange}
                                label="Security Cheque No *"
                              />
                              {this.state.formError.SecurityChequeNo !==
                              null ? (
                                <div className="error">
                                  {this.state.formError.SecurityChequeNo}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </>
              ) : (
                ""
              )}

              {this.state.RoleId === "9" && (
                <DistributorSection
                  {...this.state}
                  formError={this.state.formError}
                  handleChange={this.handleChange}
                  getCityList={this.getCityList}
                  getDCityList={this.getDCityList}
                  setImagePath={this.setImagePath}
                  setImagePath2={this.setImagePath2}
                  setImagePathAccountHolder={this.setImagePathAccountHolder}
                  setImagePathAccountHolder2={this.setImagePathAccountHolder2}
                  setImagePathAccountHolder3={this.setImagePathAccountHolder3}
                  setImagePathAccountHolder4={this.setImagePathAccountHolder4}
                  setImagePathAccountHolder5={this.setImagePathAccountHolder5}
                  StateData={this.props.StateData}
                  UserBCityData={this.props.UserBCityData}
                  ResStateData={this.props.ResStateData}
                  UserRCityData={this.props.UserRCityData}
                  UserFirmData={this.props.UserFirmData}
                  UserPayMentData={this.props.UserPayMentData}
                />
              )}

              <div className="col-md-12  mapping_submitbtncol mt-3 mb-3 text-center">
                {this.state.IsEdit === true ? (
                  <Button
                    type="submit"
                    label={this.state.buttonLabel}
                    icon="pi pi-check"
                    className="p-button-success"
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12">
                Note: Fields marked as (*) are required
              </div>
            </div>
          </form>
        </Dialog>

        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.props.onHideShowIsActive(false)}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>
              Are you sure you want to{" "}
              {this.state.switchAction == true ? "Active" : "InActive"}?
            </span>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DocumentTypes: state.dealer.GetDocumentTypeDDl || [],
    SalesPersonIdList: state.dealer.GetSalesPersonListDDl || [],
    UserRoleData: state.user.rollddl,
    UserData: state.dealer.items,
    StateData: state.dealer.stateddl,
    ResStateData: state.dealer.dstateddl || [],
    UserBCityData: state.dealer.bcityddl,
    UserRCityData: state.dealer.dcityddl || [],
    DistrictData: state.dealer.Districtddl,
    UserFirmData: state.dealer.firmddl || [],
    UserPayMentData: state.dealer.UserPaymentDDL || [],
    showDialog: state.role.showDialog,
    loading: state.company.loding,
    showIsActiveDialog: state.user.showIsActiveDialog,
    DistributorDDL: state.dealer.DistributorDDL || [],

    List:
      state.dealer.exportitems == (null || undefined)
        ? []
        : state.dealer.exportitems,
  };
};

const downloadUserRegForm = (url) => {
  if (url) {
    window.open(url, "_blank");
  } else {
    alert("No document available.");
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(dealerMasterActions.getAll(obj));
    },
    createDealer: (user, obj) =>
      dispatch(dealerMasterActions.createDealer(user, obj)),
    createDistributor: (data, obj) =>
      dispatch(dealerMasterActions.createDistributor(data, obj)),
    updateDistributor: (data, obj) =>
      dispatch(dealerMasterActions.updateDistributor(data, obj)),
    updateDealer: (user, obj) =>
      dispatch(dealerMasterActions.updateDealer(user, obj)),
    inActiveRow: (user, isActive) =>
      dispatch(dealerMasterActions.inActiveRow(user, isActive)),
    updatePaymentStatus: (user, isPayment) =>
      dispatch(dealerMasterActions.updatePaymentStatus(user, isPayment)),
    onHideShow: (isbool) => dispatch(dealerMasterActions.onHideShow(isbool)),
    onHideShowIsActive: (isbool) =>
      dispatch(dealerMasterActions.onHideShowIsActive(isbool)),
    getStateDDL: (data) => dispatch(dealerMasterActions.getStateDDL(data)),
    getDStateDDL: (data) => dispatch(dealerMasterActions.getDStateDDL(data)),
    getFirmDDL: () => dispatch(dealerMasterActions.getFirmDDL()),
    GETPAYMENTDDL: () => dispatch(dealerMasterActions.GETPAYMENTDDL()),
    GETDOCUMENTTYPEDDL: () =>
      dispatch(dealerMasterActions.GETDOCUMENTTYPEDDL()),
    GetSalesPersonDDL: () => dispatch(dealerMasterActions.GetSalesPersonDDL()),
    getBCityDDL: (data) => dispatch(dealerMasterActions.getBCityDDL(data)),
    getDCityDDL: (data) => dispatch(dealerMasterActions.getDCityDDL(data)),
    getDistrictDDL: (data) =>
      dispatch(dealerMasterActions.getDistrictDDL(data)),
    getTransportationModeDDL: () =>
      dispatch(dealerMasterActions.getTransportationModeDDL()),
    loadingData: (isLoding) =>
      dispatch(dealerMasterActions.loadingData(isLoding)),
    GetDistributorByUserId: (userId) =>
      dispatch(dealerMasterActions.GetDistributorByUserId(userId)),
    getRoleDDL: (data) => dispatch(userMasterActions.getRoleDDL(data)),
    exportData: (obj) => {
      dispatch(dealerMasterActions.exportData(obj));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(dealerMaster);
